import { Component, OnInit } from '@angular/core';
import { ExpenseService } from 'app/shared/services/expense.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';


@Component({
  selector: 'app-expenses-analysis-report',
  templateUrl: './expenses-analysis-report.component.html',
  styleUrls: ['./expenses-analysis-report.component.css']
})
export class ExpensesAnalysisReportComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>

  fromDate : Date;
  toDate : Date;
  expCategory =null;
  isDark: boolean = false;

  expenseLst : any[]=[];
  filteredExpenseList : any[]=[];


  EXP_TYPES =[
    {value: 'Administration'},
    {value: 'Fish and Meat'},
    {value: 'Grocery'},
    {value: 'Boat Charge'},
    {value: 'Transport'},
    {value: 'Distribution'},
    {value: 'Marketing'},
    {value: 'Maintenance'},
    {value: 'Salary'},
    {value: 'Finance'},
    {value: 'Overhead'},
    {value: 'Other'},
  ];

  constructor(
              private expenseService : ExpenseService, 
              private router : Router, 
              private themeService: NbThemeService,
              private decimalPipe : DecimalPipe
             )
              {
                this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

              }

    ngOnInit() {
      this.getAllExpBreakup();    
      
      this.themeService.onThemeChange()
      .subscribe(themeName =>{
       this.isDark  = themeName.name ==='dark' ? true : false;
     });
    }

 
    getAllExpBreakup(){
    this.expenseService.getAllExpBreakup()
     .subscribe(
        (data) => {
                  this.expenseLst = data;  
                  this.filteredExpenseList =   this.expenseLst;                           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

     getTotal(){
      return this.filteredExpenseList.map(totalBal=>totalBal.Amount).reduce((acc,value)=>acc + +value,0);
    }
    

      viewBtnClicked(){
        if(this.fromDate && this.toDate && this.expCategory){
            var startDate =moment(this.fromDate).format("YYYY-MM-DD");
            var endDate =moment(this.toDate).format("YYYY-MM-DD");
                
            this.filteredExpenseList = this.expenseLst.filter(data => {
                  var expDate = moment(data.ExpDate).format("YYYY-MM-DD");              
                  return moment(expDate).isBetween(startDate, endDate,undefined,'[]') && 
                  data.ExpCategory.toLowerCase().indexOf(this.expCategory.trim().toLowerCase()) !==-1;
                  });
        }
        
        else if(this.fromDate && this.toDate){
          var startDate =moment(this.fromDate).format("YYYY-MM-DD");
          var endDate =moment(this.toDate).format("YYYY-MM-DD");
     
          this.filteredExpenseList = this.expenseLst.filter(data => {
                var expDate = moment(data.ExpDate).format("YYYY-MM-DD");              
                return moment(expDate).isBetween(startDate, endDate,undefined,'[]');              
                });
        }

        else if(this.expCategory){
          this.filteredExpenseList = this.expenseLst.filter(data => {                         
                 return data.ExpCategory.toLowerCase().indexOf(this.expCategory.trim().toLowerCase()) !==-1;            
                });
        }

      }


     clearBtnClicked(){
      this.fromDate = null;
      this.toDate = null;
      this.expCategory  = null;
      this.filteredExpenseList =   this.expenseLst;    
     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'portrait',

        content: [   
          { text: 'Expenses Analysis Report', style: 'reportHeader' }, 
          { text: (this.fromDate && this.toDate) ? `${moment(this.fromDate).format("YYYY-MM-DD")} To ${moment(this.toDate).format("YYYY-MM-DD")}` : '',alignment: 'center',margin: [0,5,0,5] }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', 'auto','auto', '*', 'auto', 'auto'],  
                body: [  
                  ['ExpDate', 'ExpNo','supplier',  'Expense', 'Category', 'Remarks', 'Amount'],
                  ...this.filteredExpenseList.map(p => ([moment(p.ExpDate).format("YYYY-MM-DD"), p.ExpNo,p.SupName, p.ExpName,p.ExpCategory,p.Remarks, {text : this.transformNumberFormat(p.Amount), alignment: 'right'  }])),  
                  [ { text: 'Total ', bold: true, colSpan: 6 }, {},{},{},{},{}, { text :  this.transformNumberFormat(this.getTotal()),alignment: 'right', bold : true } ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 10],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('expReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Expenses Analysis Report.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
   }


}
